import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { Mortgage as MortgageComponent } from '../../components/Mortgage';
import { getBanks } from '../../selectors';
import { BankCard } from '../../components/BankCard';

export function Mortgage() {
  const banks = useSelector(getBanks);
  const bankCards = React.useMemo(() => banks.map(bank => <BankCard key={bank.id} bank={bank} />), [banks]);

  if (!bankCards.length) {
    return null;
  }

  return (
    <MortgageComponent
      title={<ArticleHeading1>Ипотека от банков</ArticleHeading1>}
      banks={bankCards}
      getMortgage={null}
    />
  );
}
